var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConfirmed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_96_4276)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.400391,
    width: 24,
    height: 24,
    rx: 4,
    fill: "#D9F7BE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.06641 9.7576C4.06641 9.35996 4.38876 9.0376 4.78641 9.0376H20.1862C20.5838 9.0376 20.9062 9.35996 20.9062 9.7576C20.9062 10.1553 20.5838 10.4776 20.1862 10.4776H4.78641C4.38876 10.4776 4.06641 10.1553 4.06641 9.7576Z",
    fill: "#237804"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9759 2.63989C16.3735 2.63989 16.6959 2.96225 16.6959 3.35989V6.20316C16.6959 6.6008 16.3735 6.92316 15.9759 6.92316C15.5782 6.92316 15.2559 6.6008 15.2559 6.20316V3.35989C15.2559 2.96225 15.5782 2.63989 15.9759 2.63989Z",
    fill: "#237804"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.99539 2.63989C9.39304 2.63989 9.71539 2.96225 9.71539 3.35989V6.20316C9.71539 6.6008 9.39304 6.92316 8.99539 6.92316C8.59775 6.92316 8.27539 6.6008 8.27539 6.20316V3.35989C8.27539 2.96225 8.59775 2.63989 8.99539 2.63989Z",
    fill: "#237804"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.31958 5.23435C6.20184 4.3957 7.42976 4.00488 8.82832 4.00488H16.1439C17.5456 4.00488 18.7742 4.39539 19.6552 5.23499C20.5415 6.07983 20.9824 7.29012 20.9783 8.73715C20.9783 8.73693 20.9783 8.73736 20.9783 8.73715V16.621C20.9783 18.0682 20.5355 19.2797 19.649 20.1259C18.7677 20.9672 17.5391 21.3603 16.1364 21.3603H8.82832C7.42544 21.3603 6.19596 20.9588 5.31454 20.1045C4.42953 19.2467 3.98633 18.0206 3.98633 16.5557V8.73572C3.98633 7.28788 4.43175 6.07828 5.31958 5.23435ZM6.31169 6.27805C5.77297 6.79012 5.42633 7.58594 5.42633 8.73572V16.5557C5.42633 17.7294 5.77519 18.5456 6.31673 19.0705C6.86184 19.5989 7.69336 19.9203 8.82832 19.9203H16.1364C17.2789 19.9203 18.1114 19.6029 18.6547 19.0843C19.1928 18.5706 19.5383 17.7724 19.5383 16.621V8.73572V8.73365C19.5417 7.58335 19.1979 6.78846 18.6617 6.2774C18.1199 5.76098 17.2874 5.44488 16.1439 5.44488H8.82832C7.68904 5.44488 6.85597 5.76067 6.31169 6.27805Z",
    fill: "#237804"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0929 12.6654C16.3742 12.9465 16.3743 13.4023 16.0932 13.6836L12.6214 17.1573C12.4863 17.2925 12.3029 17.3684 12.1119 17.3683C11.9207 17.3683 11.7376 17.2923 11.6025 17.157L9.91749 15.4693C9.63655 15.1878 9.63692 14.7319 9.91834 14.451C10.1998 14.17 10.6557 14.1704 10.9366 14.4518L12.1124 15.6296L15.0747 12.6656C15.3558 12.3844 15.8117 12.3842 16.0929 12.6654Z",
    fill: "#237804"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_96_4276"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.400391,
    width: 24,
    height: 24,
    rx: 4,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmed);
export default __webpack_public_path__ + "static/media/confirmed.12c624a04da7da32c252bb47bd6048ce.svg";
export { ForwardRef as ReactComponent };